// Constants and pure helpers shared across admin components.
// No Prisma client / env reads in this file — safe for client bundles.

export type OrderStatus =
  | "PENDING"
  | "IN_PROGRESS"
  | "IN_REVIEW"
  | "REVISIONS_PENDING"
  | "COMPLETED"
  | "CANCELLED";

export type PackageType =
  | "LANDING_PAGE"
  | "BRAND_PACKAGE"
  | "BASIC_MVP"
  | "ADVANCED_MVP";

export type OrdersListSort =
  | "createdAt_desc"
  | "createdAt_asc"
  | "deadlineAt_asc"
  | "deadlineAt_desc"
  | "priceUsd_desc"
  | "priceUsd_asc";

export const STATUS_LABEL: Record<OrderStatus, string> = {
  PENDING: "Pending",
  IN_PROGRESS: "In progress",
  IN_REVIEW: "In review",
  COMPLETED: "Completed",
  REVISIONS_PENDING: "Revisions pending",
  CANCELLED: "Cancelled",
};

export const PACKAGE_LABEL: Record<PackageType, string> = {
  LANDING_PAGE: "Landing Page",
  BRAND_PACKAGE: "Branding Package",
  BASIC_MVP: "Basic MVP",
  ADVANCED_MVP: "Advanced MVP",
};

// Local type for an order row (all date fields are ISO strings from the API).
export type OrderRow = {
  id: string;
  orderNumber: string;
  businessName: string;
  contactName: string;
  contactEmail: string;
  status: OrderStatus;
  packageType: PackageType;
  paidAt: string | null;
  deadlineAt: string;
  createdAt: string;
  priceUsd: number;
};

export type OrdersListResult = {
  rows: OrderRow[];
  total: number;
  pageCount: number;
  page: number;
};

// Whether a paid, non-terminal order has blown its deadline.
// Date fields arrive as ISO strings from the API.
export function isOverdue(order: {
  status: OrderStatus;
  deadlineAt: string;
  paidAt: string | null;
}): boolean {
  if (!order.paidAt) return false;
  if (order.status === "COMPLETED" || order.status === "CANCELLED") return false;
  return new Date(order.deadlineAt).getTime() < Date.now();
}
